import * as _ from 'underscore';

// This entire file ought to be replaced with functions from tableau-shared-urls
import { WorkbookSubspaceName } from '../../state/SpaceInfo';

export namespace WorkbookSpaceConfigHelper {

  export interface WorkbookSubspace {
    name: WorkbookSubspaceName;
    urlSuffix: string;
  }

  export const WorkbookSubspaces: WorkbookSubspace[] = [
    {
      name: 'views',
      urlSuffix: 'views',
    },
    {
      name: 'datasources',
      urlSuffix: 'datasources',
    },
    {
      name: 'extractTasks',
      urlSuffix: 'extractRefreshes',
    },
    {
      name: 'subscriptions',
      urlSuffix: 'subscriptions',
    },
    {
      name: 'lineage',
      urlSuffix: 'lineage',
    }
  ];

  export function urlSuffixFromSubspaceName(subspaceName: WorkbookSubspaceName): string | undefined {
    const subspace = _(WorkbookSubspaces).findWhere({ name: subspaceName });
    return subspace && subspace.urlSuffix || undefined;
  }
}
